import AppMenuBar from '@/components/AppMenu/AppMenubar';
import HeaderBreadcrumbs from '@/components/header/HeaderBreadcrumbs';
import HeaderLogo from '@/components/header/HeaderLogo';
import HeaderSearch from '@/components/header/HeaderSearch';
import UserHelpBtn from '@/components/header/user/UserHelpBtn';
import UserMenu from '@/components/header/user/UserMenu';

import { Box, Center, Group, Title } from '@mantine/core';
import { useTranslate } from '@tolgee/react';
import { useMatch, useNavigate } from 'react-router-dom';

export const Header = () => {
  const { t } = useTranslate();
  const navigate = useNavigate();

  const isOnboardingPage = useMatch('/onboarding');

  const gotToHome = () => {
    navigate('/');
  };

  return (
    <Box>
      <Box bg="gray.0" p="xs">
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Group wrap="nowrap">
            <HeaderLogo />
            <Box c="gray.8">
              <Title
                order={3}
                onClick={gotToHome}
                style={{
                  cursor: 'pointer',
                }}
              >
                {t('app.welcome')}
              </Title>
              <HeaderBreadcrumbs />
            </Box>
          </Group>
          <Group justify="flex-end" wrap="nowrap">
            {!isOnboardingPage && (
              <>
                <HeaderSearch />
                <Center visibleFrom="sm">
                  <UserHelpBtn />
                </Center>
              </>
            )}
            <UserMenu />
          </Group>
        </Box>
      </Box>
      {!isOnboardingPage && <AppMenuBar />}
    </Box>
  );
};
